<template>
  <pdp-section-gallery>
    <template #default="{ i }" v-if="productHasTryItOnAsset">
      <div class="absolute right-0 top-0 mr-3 mt-15 f-col items-start gap-4 lg:m-6">
        <base-button
          v-if="(productHasTryItOnAsset && $feature.showTryItOnCtaOnPDP) && galleryItems[i].type !== 'video'"
          id="pdp-try-it-on"
          class="body-4 flex center gap-2 rounded-xs bg-white/70 p-2 c-black shadow-sm backdrop-blur-md"
          :class="{ 'lg:hidden': i !== 0 }"
          @click="tryItOn"
        >
          <vf-icon name="try-it-on" size="md" />
          <span>{{ $t.tryItOn }}</span>
        </base-button>
        <p
          v-if="product?.modelMeasurements?.length && i === (galleryItems.length > 2 ? 2 : 0)"
          class="body-4 pointer-events-none w-fit bg-white/70 p-2 backdrop-blur-md"
        >
          {{ product?.modelMeasurements[0] }}
        </p>
      </div>
    </template>
  </pdp-section-gallery>
</template>

<script lang="ts" setup>
import PdpSectionGallery from '#brand/components/pdp/section/Gallery.vue'

const { $feature } = useNuxtApp()
const { galleryItems, product, tryItOn } = usePdp()

const tryItOnProducts = $feature.tempShowTryItOnCtaForEachImageInGallery
  ? (await import('#brand/assets/vyking-products.json')).default
  : []

const productHasTryItOnAsset = computed(() => tryItOnProducts.includes(product.value?.id?.toLowerCase()!))
</script>
